import { Mail } from 'lucide-react'
import { TemplateLibrary } from './TemplateLibrary'

export function EmailsPage() {
  return (
    <TemplateLibrary
      model="email"
      icon={Mail}
      title="Email"
      description={
        <>
          Template transazionali multilingua inviati ai clienti (conferme, promemoria, cancellazioni). Le aree{' '}
          <span className="text-coal">evidenziate</span> sono variabili sostituite all’invio. Clicca{' '}
          <span className="text-coal">Modifica</span> per cambiare oggetto e testo, e usa l’elenco delle variabili.
        </>
      }
      showSubject
      unit="template"
      unitPlural="Template"
      searchPlaceholder="Cerca template…"
    />
  )
}
